require('./form.less');
let functions = require('../../modules/functions');

jQuery(function() {
    module.exports.formValidateDefaults = {
        errorPlacement: function(error, element) {
            element.addClass('form__input--error');
            element.removeClass('form__input--correct');
            let $elParent = element.parent();
            $elParent.removeClass('icon-field--correct');
            error.addClass('form__error-msg');

            if (
                element.attr('type') == 'checkbox' ||
                element.attr('type') == 'radio' ||
                element.attr('type') == 'file'
            ) {
                let $formField = element.closest('.form__field');
                let $headlabel = $formField.find('.prompt__head-label').first();
                error.addClass('form__error-msg--custom');

                if ($headlabel.length > 0) {
                    error.insertAfter($headlabel);
                } else {
                    $formField.prepend(error);
                }
            } else {
                error.insertBefore($elParent);
            }
        },
        focusInvalid: false,
        onkeyup: false,
        success: function(label, element) {
            label.remove();
            let $el = $(element).removeClass('form__input--error');
            $el.addClass('form__input--correct');
            let $elParent = $el.parent();
            $elParent.addClass('icon-field--correct');
        },
        errorElement: 'div',
        onclick: false
    };

    functions.setMaskedPhone($('.js-masked-phone'));
    functions.setMaskedPhoneCity($('.js-masked-phone-city'));
    functions.setMaskedPhoneMobile($('.js-masked-phone-mobile'));
});



// WEBPACK FOOTER //
// ./blocks/form/form.js